// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"KY-z","sponsoredTooltipWrapper":"LY-z","sponsoredTooltip":"MY-z","newCard":"NY-z"};